import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useWishlistStore } from "@/store/wishlistStore";
import { useNavigate } from "react-router-dom";
import { Heart, LogIn, Bookmark } from "lucide-react";
import { alertToast } from "@/contexts/AlertToastContext";
import { useStaticTranslation } from "@/lib/staticTranslations";

export const WishlistLoginPrompt = () => {
  const navigate = useNavigate();
  const { 
    showLoginPrompt, 
    pendingProduct, 
    setShowLoginPrompt, 
    setPendingProduct,
    addItemLocal 
  } = useWishlistStore();
  const { t, isHebrew } = useStaticTranslation("wishlistPrompt");

  const handleLogin = () => {
    setShowLoginPrompt(false);
    navigate('/auth');
  };

  const handleSaveLocally = () => {
    if (pendingProduct) {
      addItemLocal(pendingProduct);
      alertToast.success(t("savedSuccess", "המוצר נשמר למועדפים!"));
    }
    setShowLoginPrompt(false);
    setPendingProduct(null);
  };

  const handleClose = () => {
    setShowLoginPrompt(false);
    setPendingProduct(null);
  };

  return (
    <Dialog open={showLoginPrompt} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md" dir={isHebrew ? "rtl" : "ltr"}>
        <DialogHeader className={isHebrew ? "text-right" : "text-left"}>
          <div className="flex justify-center mb-4">
            <div className="bg-primary/10 p-4 rounded-full">
              <Heart className="h-8 w-8 text-primary" />
            </div>
          </div>
          <DialogTitle className="text-center text-xl">{t("title", "שמירת מוצר למועדפים")}</DialogTitle>
          <DialogDescription className="text-center text-base mt-2">
            {t("subtitle", "איך תרצה לשמור את המוצר?")}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 py-4">
          <Button 
            onClick={handleLogin}
            className="w-full h-12 text-base"
            variant="default"
          >
            <LogIn className={`h-5 w-5 ${isHebrew ? "ml-2" : "mr-2"}`} />
            {t("loginButton", "התחבר לחשבון")}
            <span className={`text-xs opacity-70 ${isHebrew ? "mr-2" : "ml-2"}`}>{t("recommended", "(מומלץ)")}</span>
          </Button>
          
          <Button 
            onClick={handleSaveLocally}
            variant="outline"
            className="w-full h-12 text-base"
          >
            <Bookmark className={`h-5 w-5 ${isHebrew ? "ml-2" : "mr-2"}`} />
            {t("saveLocally", "שמור בלי התחברות")}
          </Button>
        </div>

        <DialogFooter className="text-center">
          <p className="text-xs text-muted-foreground w-full">
            {t("footerNote", "שמירה עם התחברות מאפשרת גישה למועדפים מכל מכשיר")}
          </p>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
